import React from 'react';

export const settings = {
  header: {
    showHeaderLogo: true
  }
};

export const AppContext = React.createContext(settings);